import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "user-stats" }

import { ComputedRef, computed, toRefs } from 'vue'
  import { useI18n } from 'vue-i18n'

  import StatCard from '@/components/Common/StatCard.vue'
  import { TUnit } from '@/types/units'
  import { IAuthUserProfile } from '@/types/user'
  import { convertDistance, units } from '@/utils/units'
  interface Props {
    user: IAuthUserProfile
  }
  
export default /*#__PURE__*/_defineComponent({
  props: {
    user: null
  },
  setup(__props: any) {

const props = __props as {
    user: IAuthUserProfile
  }

  

  const { t } = useI18n()

  const { user } = toRefs(props)
  const userTotalDuration: ComputedRef<string> = computed(
    () => props.user.total_duration
  )
  const totalDuration = computed(() => get_duration(userTotalDuration))
  const defaultUnitFrom: TUnit = 'km'
  const unitTo: TUnit = user.value.imperial_units
    ? units[defaultUnitFrom].defaultTarget
    : defaultUnitFrom
  const totalDistance: ComputedRef<number> = computed(() =>
    user.value.imperial_units
      ? convertDistance(user.value.total_distance, defaultUnitFrom, unitTo, 2)
      : parseFloat(user.value.total_distance.toFixed(2))
  )

  function get_duration(total_duration: ComputedRef<string>) {
    const duration = total_duration.value.match(/day/g)
      ? total_duration.value.split(', ')[1]
      : total_duration.value
    return {
      days: total_duration.value.match(/day/g)
        ? `${total_duration.value.split(' ')[0]} ${
            total_duration.value.match(/days/g)
              ? t('common.DAY', 2)
              : t('common.DAY', 1)
          }`
        : `0 ${t('common.DAY', 2)},`,
      duration: `${duration.split(':')[0]}h ${duration.split(':')[1]}min`,
    }
  }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(StatCard, {
      icon: "calendar",
      value: _unref(user).nb_workouts,
      text: _ctx.$t('workouts.WORKOUT', _unref(user).nb_workouts)
    }, null, 8, ["value", "text"]),
    _createVNode(StatCard, {
      icon: "road",
      value: _unref(totalDistance),
      text: _unref(unitTo) === 'mi' ? 'miles' : _unref(unitTo)
    }, null, 8, ["value", "text"]),
    _createVNode(StatCard, {
      icon: "clock-o",
      value: _unref(totalDuration).days,
      text: _unref(totalDuration).duration
    }, null, 8, ["value", "text"]),
    _createVNode(StatCard, {
      icon: "tags",
      value: _unref(user).nb_sports,
      text: _ctx.$t('workouts.SPORT', _unref(user).nb_sports)
    }, null, 8, ["value", "text"])
  ]))
}
}

})